import React, { Component } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { TRANSACTION_HISTORY_REPORT_FORM_NAME } from 'Common/FormEnum';
import { TransactionHistoryReportEnum } from 'Common/FieldEnum';
import * as FilterSelector from 'State/filters/selectors';

import TransactionHistoryReportComponent from '../components/TransactionHistoryReport';
import * as CommonPrintSelector from '../../commonState/selectors';
import * as TransactionHistorySelector from '../state/selectors';

class TransactionHistoryReport extends Component {
  static propTypes = {
    dropdownItems: PropTypes.array.isRequired,
    sitesData: PropTypes.array.isRequired,
    transactionTypesData: PropTypes.array.isRequired,
    itemSortOptionsValue: PropTypes.number,
    bidGroupData: PropTypes.array.isRequired,
    itemGroupData: PropTypes.array.isRequired,
    acctCategoryData: PropTypes.array.isRequired,
    vendorData: PropTypes.array.isRequired,
  };

  state = {
    activeIndexes: [0, 1],
  };

  clearFilters = () => {
    const { reset, change } = this.props;
    const selectedSitesCopy = [...this.props.selectedSites];
    reset();
    change(TransactionHistoryReportEnum.SiteIds, selectedSitesCopy);
  };

  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };

  render() {
    const {
      sitesData,
      itemPrintOptionsValue,
      dropdownItems,
      bidGroupData,
      itemGroupData,
      acctCategoryData,
      vendorData,
      itemSortOptionsValue,
      transactionTypesData,
      initialSelectedSiteIds,
      setSelectedSites,
      loadingSitesData,
      reactTableRef,
    } = this.props;
    return (
      <TransactionHistoryReportComponent
        handleCollapsePanelClick={this.handleCollapsePanelClick}
        activeIndexes={this.state.activeIndexes}
        clearFilters={this.clearFilters}
        sitesData={sitesData}
        itemPrintOptionsValue={itemPrintOptionsValue}
        dropdownItems={dropdownItems}
        bidGroupData={bidGroupData}
        itemGroupData={itemGroupData}
        acctCategoryData={acctCategoryData}
        vendorData={vendorData}
        itemSortOptionsValue={itemSortOptionsValue}
        transactionTypesData={transactionTypesData}
        setSelectedSites={setSelectedSites}
        initialSelectedSiteIds={initialSelectedSiteIds}
        loadingSitesData={loadingSitesData}
        reactTableRef={reactTableRef}
      />
    );
  }
}

TransactionHistoryReport = reduxForm({
  form: TRANSACTION_HISTORY_REPORT_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(TransactionHistoryReport);

const selector = formValueSelector(TRANSACTION_HISTORY_REPORT_FORM_NAME);
const mapStateToProps = state => {
  return {
    itemSortOptionsValue: selector(
      state,
      TransactionHistoryReportEnum.ItemSortOptions
    ),
    dropdownItems: TransactionHistorySelector.getDropdownItems(state),
    sitesData: TransactionHistorySelector.getSitesData(state),
    transactionTypesData: CommonPrintSelector.getTransactionTypesData(state),

    bidGroupData: FilterSelector.getBidGroupData(state),
    itemGroupData: FilterSelector.getItemGroupData(state),
    acctCategoryData: FilterSelector.getAcctCategoryData(state),
    vendorData: FilterSelector.getVendorData(state),
  };
};

export const TransactionHistoryReportContainer = connect(
  mapStateToProps,
  null
)(TransactionHistoryReport);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/transactionhistoryreport/containers/TransactionHistoryReport.js